/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text ↔ Morse code`)
};

const es_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto ↔ Código Morse`)
};

const de_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text ↔ Morse`)
};

const nl_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekst ↔ Morsecode`)
};

const fr_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte ↔ Code Morse`)
};

const it_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo ↔ Codice Morse`)
};

const pt_br2_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto ↔ Código Morse`)
};

const pt_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto ↔ Código Morse`)
};

const ja_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキスト ↔ モールス信号`)
};

const zh_mc_nav_main_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本 ↔ 摩尔斯电码`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_nav_main_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_nav_main_desc(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_nav_main_desc", locale)
	if (locale === "en") return en_mc_nav_main_desc(inputs)
	if (locale === "es") return es_mc_nav_main_desc(inputs)
	if (locale === "de") return de_mc_nav_main_desc(inputs)
	if (locale === "nl") return nl_mc_nav_main_desc(inputs)
	if (locale === "fr") return fr_mc_nav_main_desc(inputs)
	if (locale === "it") return it_mc_nav_main_desc(inputs)
	if (locale === "pt-BR") return pt_br2_mc_nav_main_desc(inputs)
	if (locale === "pt") return pt_mc_nav_main_desc(inputs)
	if (locale === "ja") return ja_mc_nav_main_desc(inputs)
	return zh_mc_nav_main_desc(inputs)
};